import { render, staticRenderFns } from "./Post.vue?vue&type=template&id=205cf709&scoped=true&"
import script from "./Post.vue?vue&type=script&lang=js&"
export * from "./Post.vue?vue&type=script&lang=js&"
import style0 from "./Post.vue?vue&type=style&index=0&id=205cf709&prod&lang=sass&scoped=true&"
import style1 from "./Post.vue?vue&type=style&index=1&id=205cf709&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205cf709",
  null
  
)

export default component.exports